import { useState } from 'react';
import { TextField, Box, InputAdornment } from '@mui/material';
import ColorPicker from 'components/ColorPicker';


const ColorField = ({ field, value, setFieldValue, error, helperText, disabled }) => {
    const [anchor, setAnchor] = useState(null);
    return (
        <>
            <TextField
                label={field.label}
                name={field.name}
                value={value ?? ''}
                variant="filled"
                size="small"
                fullWidth
                disabled={disabled}
                error={!!error}
                helperText={helperText}
                placeholder="#3B82F6"
                onClick={e => setAnchor(e.currentTarget)}
                onChange={e => setFieldValue(field.name, e.target.value)}
                sx={{ gridColumn: `span ${field.formSpan || 6}` }}
                slotProps={{
                    htmlInput: { style: { cursor: 'pointer' } },
                    input: {
                        startAdornment: value ? (
                            <InputAdornment position="start">
                                <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: value, border: '1px solid', borderColor: 'divider' }} />
                            </InputAdornment>
                        ) : null,
                    },
                }}
            />
            <ColorPicker
                anchorEl={anchor}
                onClose={() => setAnchor(null)}
                value={value ?? ''}
                onChange={c => setFieldValue(field.name, c)}
            />
        </>
    );
};

export default ColorField;
